import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    date: Object
  },
  data: function data() {
    return {
      data: [{
        id: 1,
        label: '制度引擎',
        children: [{
          id: 4,
          label: '字典组1'
        }, {
          id: 9,
          label: '字典组2'
        }, {
          id: 10,
          label: '字典组3'
        }]
      }, {
        id: 2,
        label: '员工积分',
        children: [{
          id: 5,
          label: '字典组测试1号'
        }, {
          id: 6,
          label: '字典组测试2号'
        }]
      }, {
        id: 3,
        label: '监督检查',
        children: [{
          id: 7,
          label: '子字典组1'
        }, {
          id: 8,
          label: '子字典组2'
        }]
      }],
      flatData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      selectedArr: [],
      selectData: [],
      systemId: '',
      dicts: [],
      loading: false,
      checkedDict: []
    };
  },
  created: function created() {
    this.systemId = this.date.systemId;
    this.flatData = this.data.reduce(function (pre, item) {
      // let copyObj = JSON.parse(JSON.stringify(item));
      // delete copyObj.children;
      // pre.push(copyObj)
      if (item.children) {
        pre = pre.concat(item.children);
      }
      return pre;
    }, []);
  },
  methods: {
    changeDict: function changeDict(e, item) {
      var _this = this;
      if (e) {
        this.$API.postRequest({
          url: '/platform/virtualDict/addRelation',
          data: {
            virtualGroupId: this.date.id,
            realGroupId: item.id
          }
        }).then(function () {
          _this.changeSystemId();
          _this.$emit('refresh');
        });
      } else {
        this.$API.getRequest({
          url: "/platform/virtualDict/deleteRelation/".concat(item.id)
        }).then(function () {
          _this.$emit('refresh');
        });
      }
    },
    delOrgFn: function delOrgFn() {},
    changeSystemId: function changeSystemId() {
      var _this2 = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/virtualDict/getNotAssociated',
        data: {
          realSystemId: this.selectedArr[0],
          virtualGroupId: this.date.id
        }
      }).then(function (res) {
        _this2.loading = false;
        _this2.dicts = res.result;
      });
    }
  }
};